/**
 * Single source of truth for env-var reads in @pentacode/core.
 *
 * Reads `process.env` (not `import.meta.env`) because core compiles to CJS
 * and is consumed by both the server (real Node `process.env`) and browser
 * apps (vite `define` substitutes at bundle time).
 *
 * The shim below covers a quirk: some browser contexts (notably the
 * vite-plugin-pwa service-worker dev bundle) skip vite's `define` pass for
 * `process.env.PTC_*` references, leaving the literal `process` access in
 * the served code. Without `globalThis.process`, that throws
 * `ReferenceError: process is not defined`. Stubbing it lets the access
 * fall through to `undefined` and the `?? ""` defaults below.
 */
globalThis.process ??= { env: {} };
export const PUBLIC_PTC_FULL_VERSION = process.env.PUBLIC_PTC_FULL_VERSION ?? "";
export const PUBLIC_PTC_CHANGELOG = process.env.PUBLIC_PTC_CHANGELOG;
//# sourceMappingURL=env.js.map